// ── Subscription plan tiers ───────────────────────────────────────────────────
// Used when sending plan_tier to the server (POST /auth/register, upgrade, etc.)

export const PLAN_TIERS = ['Individual', 'Business', 'Professional', 'Enterprise'];

export const PLAN_TIER = {
  INDIVIDUAL:   'Individual',
  BUSINESS:     'Business',
  ENTERPRISE:   'Enterprise',
  PROFESSIONAL: 'Professional',
};

export const DEFAULT_PLAN_TIER = PLAN_TIER.INDIVIDUAL;
